/**
 * Manage the data on localStorage
 */
const TokenService = {

    initStorage(data, datetime) {
        let devices = [];
        for (const device of data.devices) {
            devices.push({
                device: device.device
            })
        }

        let perms = {};
        for (const permission of data.role.permission) {
            // if (permission.access) {
            // let methods = [];
            let submodules = [];
            let components = [];
            for (const component of permission.components) {
                // if (meth.access) {
                // methods.push(meth.title.toLowerCase());
                components.push(component);
                // }
            }
            for (const submodule of permission.subModules) {
                // if (meth.access) {
                // methods.push(meth.title.toLowerCase());
                submodules.push(submodule);
                // }
            }

            // perms[permission.nameModule.toLowerCase()] = methods;
            let name = permission.name.toLowerCase();
            perms[name] = {
                submodules: submodules,
                components: components,
                access: permission.access
            };
            // }
        }

        let sess = {
            user: data.user,
            client: data.client,
            clients: data.clients,
            username: data.username,
            language: data.language,
            role: {
                id: data.role.id,
                name: data.role.name,
                modules: perms,
                type: data.role.type
            },
            devices: devices,
            services: data.services,
            amode: data.access_mode,
			clusters: data.activeCluster,
        };

        let invoices = data.invoices;
        /* let showInvoice = data.days2pay == null ? false : (data.days2pay >= 0 && data.days2pay <= 5) ? true : false;
        if ((data.invoices).lenght > 5) {
            for (const idx in (data.invoices)) {
                if ((data.invoices.hasOwnProperty(idx))) {
                    const element = (data.invoices[idx]);
                    if (idx < 6) {
                        invoices.push(element)
                    }
                }
            }
        } else {
            invoices = data.invoices
        } */
		let country = (data.countryCode).toLowerCase();
		country = country != 'us' ? 'mx' : 'us';

        this.setSession(sess);
        this.setToken(data.access_token);
        this.setDatetime(datetime);
        this.setCreditDays(data.days2pay);
        this.setInvoices(invoices);
		this.setItem('COUNTRY', country, false)
        // this.setShowModalCreditDays(showInvoice);

        let v = this.getVolumen();

        if (!v) {
            this.setVolumen(0.5);
        }
    },

    removeStorage() {
        this.removeDatetime();
        this.removeSession();
        this.removeToken();
        // this.removeVolumen();
        this.removeCreditDays();
        this.removeShowModalCreditDays();
        this.removeInvoices();
		this.removeItem('COUNTRY');
		this.removeItem('AUDIOS');
    },

    /** User */
    getUser() {
        let s = this.getSession();

        return s.user;
    },

    /** Lang */
    getLang() {
        let s = this.getSession();

        return (s) ? s.language : false;
    },

    /** Data */
    setSession(sess) {
        localStorage.setItem('TRCKM_SESS', JSON.stringify(sess));
    },

    getSession() {
        let d = localStorage.getItem('TRCKM_SESS');
        return JSON.parse(d);
    },

    removeSession() {
        localStorage.removeItem('TRCKM_SESS');
    },

    /** Token */
    setToken(token) {
        localStorage.setItem('TRCKM_TOKEN', token)
    },

    getToken() {
        return localStorage.getItem('TRCKM_TOKEN');
    },

    removeToken() {
        localStorage.removeItem('TRCKM_TOKEN');
    },

    /** Time */
    setDatetime(datetime) {
        localStorage.setItem('TRCKM_DT', datetime);
    },

    getDatetime() {
        return localStorage.getItem('TRCKM_DT');
    },

    removeDatetime() {
        localStorage.removeItem('TRCKM_DT');
    },

    /** Volumen */
    setVolumen(volume) {
        localStorage.setItem('TRCKM_VOL', volume);
    },

    getVolumen() {
        return localStorage.getItem('TRCKM_VOL');
    },

    removeVolumen() {
        localStorage.removeItem('TRCKM_VOL');
    },

    /** Nearby Devices **/
    setNearbyConfig(data) {
        localStorage.setItem('TRCKM_NRBDEV', JSON.stringify(data));
    },

    getNearbyConfig() {
        let nrb = localStorage.getItem('TRCKM_NRBDEV');
        return JSON.parse(nrb)
    },

    removeNearbyConfig() {
        localStorage.removeItem('TRCKM_NRBDEV');
    },
    /** Report Stop Trackings **/
    setStopTracks(data) {
        localStorage.setItem('TRCKM_STOPTRACK', JSON.stringify(data));
    },

    getStopTracks() {
        let gst = localStorage.getItem('TRCKM_STOPTRACK');
        return JSON.parse(gst)
    },

    removeStopTracks() {
        localStorage.removeItem('TRCKM_STOPTRACK');
    },
    /* getModules() {
        let s = this.getSession();
        let m = s.role.modules;
        let n = Object.keys(m);
        let r = [];

        // console.log(n);
        for (let index = 0; index < n.length; index++) {
            r.push(n[index]);
        }
        // console.log(r);

        return r;
    },
 */
    /* getPermission(module) {
        let s = this.getSession();
        let p = s.role.modules;
        // console.log(p[module]);

        if (p.hasOwnProperty(module)) {
            return p[module];
        } else {
            return false;
        }
	} */

    setCreditDays(creditDays) {
        localStorage.setItem('TRCKM_CREDITDAYS', creditDays)
    },

    setShowModalCreditDays(showit) {
        localStorage.setItem('TRCKM_SHOWCREDITDAYS', showit)
    },

    getCreditDays() {
        let c = localStorage.getItem('TRCKM_CREDITDAYS');

        return (c) ? JSON.parse(c) : null
    },

    getShowModalCreditDays() {
        return localStorage.getItem('TRCKM_SHOWCREDITDAYS');
    },

    removeCreditDays() {
        localStorage.removeItem('TRCKM_CREDITDAYS')
    },

    removeShowModalCreditDays() {
        localStorage.removeItem('TRCKM_SHOWCREDITDAYS')
    },

    setInvoices(invoices) {
        localStorage.setItem('TRCKM_INVOICES', JSON.stringify(invoices))
    },

    getInvoices() {
        return JSON.parse(localStorage.getItem('TRCKM_INVOICES'))
    },

    removeInvoices() {
        localStorage.removeItem('TRCKM_INVOICES')
    },

    setItem(name, value, isStringify) {
        if (isStringify)
            localStorage.setItem(`TRCKM_${name}`, JSON.stringify(value))
        else
            localStorage.setItem(`TRCKM_${name}`, value)
    },

    getItem(name, isParse) {
        if (isParse)
            return JSON.parse(localStorage.getItem(`TRCKM_${name}`))
        else
            return localStorage.getItem(`TRCKM_${name}`)
    },

    removeItem(name) {
        localStorage.removeItem(`TRCKM_${name}`)
    }

}

export { TokenService };
